import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { isTV } from "../utils/platform";

type UseBackNavigationProps = {
  fallbackPath?: string;
};

export const useBackNavigation = ({
  fallbackPath = "/",
}: UseBackNavigationProps = {}) => {
  const navigate = useNavigate();

  const goBack = useCallback(() => {
    const idx = isTV ? window.history.length - 1 : window.history.state?.idx;
    if (typeof idx === "number" && idx > 0) {
      navigate(-1);
    } else {
      navigate(fallbackPath, { replace: true });
    }
  }, [navigate, fallbackPath]);

  return goBack;
};
